
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.view-header {
    display:grid;
    gap:2rem;
    align-items:center;
    justify-content:center;
}@media (min-width: 768px) {.view-header {
        display:flex;
    }.view-header {
        justify-content:space-between;
    }
}.view-header {
    position:relative;
    padding-top:2rem;
    padding-bottom:2rem;
}.view-header--default::after {
    position:absolute;
}.view-header--default::after {
    bottom:0px;
}.view-header--default::after {
    display:block;
}.view-header--default::after {
    min-width:100%;
}.view-header--default::after{
    border-top:1px solid var(--neutral-gray-4);
    content:'';
  }

::slotted(.counter) {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
    font-weight:var(--fw-semibold);
    color:var(--neutral-gray-1);
}

.view-header--alternative {
    display:block;
    padding-top:0px;
}

@media (min-width: 768px) {.view-header--alternative {
        display:flex;
    }
}

.view-header--alternative .separator {
    position:relative;
}

.view-header--alternative .separator {
    height:1rem;
}

.view-header--alternative .separator {
    flex:1 1 0%;
}

.view-header--alternative .separator {
    padding-top:1rem;
    padding-bottom:1rem;
}

@media (min-width: 768px) {.view-header--alternative .separator {
        margin-left:1rem;
        margin-right:1rem;
    }
}

@media (min-width: 768px) {.view-header--alternative .separator {
        padding-top:0px;
        padding-bottom:0px;
    }
}

.view-header--alternative .separator::after {
    position:absolute;
}

.view-header--alternative .separator::after {
    top:50%;
}

.view-header--alternative .separator::after {
    display:block;
}

.view-header--alternative .separator::after {
    min-width:100%;
}

.view-header--alternative .separator::after{
      border-top:2px solid var(--neutral-gray-4);
      content:'';
    }

.view-header--locations-list {
    margin-bottom:1.5rem;
    padding-top:0px;
    padding-bottom:0px;
}

.view-header--locations-list::after {
    position:absolute;
}

.view-header--locations-list::after {
    bottom:0px;
}

.view-header--locations-list::after {
    display:block;
}

.view-header--locations-list::after {
    min-width:100%;
}

.view-header--locations-list::after{
    border-top:1px solid var(--neutral-gray-4);
    content:'';
  }

.view-header--locations-list {
  margin-bottom:0px;
}

:host([site='BH']) .view-header {
    text-align:center;
}

@media (min-width: 1024px) {:host([site='BH']) .view-header {
        justify-content:flex-end;
    }
}

@media (min-width: 1024px) {:host([site='BH']) .view-header {
        text-align:left;
    }
}

:host([site='BH']) .view-header--default, :host([site='BH']) .view-header--locations-list {
    padding-bottom:0px;
}

:host([site='BH']) .view-header--default::after, :host([site='BH']) .view-header--locations-list::after {
    display:none;
}

:host([site='BH']) ::slotted(.counter) {
    font-family:var(--bh-ff-body);
}

:host([site='BH']) ::slotted(.counter) {
    font-size:var(--bh-fs-body-02);
    line-height:var(--bh-lh-body-02);
    letter-spacing:var(--bh-ls-body-02);
}

:host([site='BH']) ::slotted(.counter) {
    font-weight:var(--fw-normal);
}

:host([site='BH']) ::slotted(.counter) {
    font-style:italic;
}

:host([site='BH']) ::slotted(ghs-form) {
    flex-grow:1;
}
`;